(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["buy-buttons"] && !Shopify.designMode) return;
  try {
    // Reveal the "limit reached" alert the instant the cart hits the max for this
  // product, without a page refresh. Server render sets the initial state; this
  // keeps it in sync on cart changes and quantity edits.
  (function () {
    function syncLimitBanners() {
      document.querySelectorAll('[data-allocation-limit]').forEach(function (banner) {
        var form = banner.closest('product-form-component');
        var input = form && form.querySelector('input[ref="quantityInput"]');
        if (!input) return;
        var max = parseInt(input.dataset.maxQuantity, 10);
        if (isNaN(max)) return;
        var cartQty = parseInt(input.dataset.cartQuantity, 10) || 0;
        // Nothing left to add for this product => at the limit.
        banner.classList.toggle('hidden', max - cartQty > 0);
      });
    }

    document.addEventListener('cart:update', syncLimitBanners);
    document.addEventListener('quantity-selector:update', syncLimitBanners);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', syncLimitBanners);
    } else {
      syncLimitBanners();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
